export const LINE_CHART_DOT_RADIUS = 3;
